import { colors } from 'shared/defaultTheme';
import styled from 'styled-components';

const Input = styled.input`
  appearance: none;
  width: 17px;
  height: 17px;
  padding: 2px !important;
  background-clip: content-box;
  border: 1px solid ${colors.black};
  border-radius: 50%;
  &:checked {
    background-color: ${colors.black};
  }
  &:disabled {
    cursor: not-allowed;
  }
`;

const Span = styled.span`
  line-height: 1;
`;

export { Input, Span };
